import Frida from './Frida.vue';
import Gloria from './Gloria.vue';

const WelcomeOffersTemplates = {
  frida: Frida,
  gloria: Gloria,
};

export default WelcomeOffersTemplates;
